/** FHA loan terms: upfront and annual mortgage insurance premium (MIP). Standard HUD table for base loans within the standard limit. */
export interface FhaTerms {
  baseLoan: number;
  upfront: number;       // 1.75% of the base loan, normally financed
  loan: number;          // base + financed upfront MIP
  ltv: number;           // base loan / price
  annualMipPct: number;
  mipMonths: number;
  minDownPct: number;
}

export const FHA_UPFRONT_PCT = 1.75;

export function fhaTerms(price: number, downAmt: number, years: number): FhaTerms {
  const baseLoan = Math.max(0, price - downAmt);
  const ltv = price > 0 ? baseLoan / price : 0;
  const longTerm = years > 15;
  const annualMipPct = longTerm ? (ltv > 0.95 ? 0.55 : 0.5) : ltv > 0.9 ? 0.4 : 0.15;
  // LTV over 90%: MIP lasts the whole loan. 90% or less: 11 years.
  const termMonths = Math.round(years * 12);
  const mipMonths = ltv > 0.9 ? termMonths : Math.min(132, termMonths);
  const upfront = Math.round(baseLoan * FHA_UPFRONT_PCT) / 100;
  return { baseLoan, upfront, loan: baseLoan + upfront, ltv, annualMipPct, mipMonths, minDownPct: 3.5 };
}
